import type { HubProject } from '@robovision/hub'
import {
  type DataTag,
  queryOptions,
} from '@tanstack/vue-query'
import { hubApi } from '~services/api'
import { queryClient } from '~services/query-client'
import { TEN_SECONDS } from './staleTimes'


function getProjectByNameQueryKey (projectName: string) {
  return ['hubApi', 'projects', 'getProjectByName', projectName] as DataTag<unknown[], HubProject>
}

export function getProjectByNameQueryOptions (projectName: string) {
  return queryOptions({
    queryFn: ({ signal }) => hubApi.projects.getProjectByName(projectName, {
      signal,
    })
      .then(response => response.data),
    queryKey: getProjectByNameQueryKey(projectName),
    // It is an arbitrary amount of time
    // to dedup consecutive requests for the same project
    staleTime: TEN_SECONDS,
  })
}

export function getProjectByName (projectName: string) {
  return queryClient.fetchQuery(getProjectByNameQueryOptions(projectName))
}
